import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api, { executeAction } from '../../../../../../helpers/api';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { t } from '../../../../../../i18n';

const api = new Api('clients/:id/invoices/:id');

function* loadData({ payload }) {
  try {
    const { id } = payload;
    const result = yield call(sendRequest, api.load, { id }, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;

      yield put(
        actions.loadDataSuccess({
          data,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* sendInvoiceRequest({ payload }) {
  try {
    const { url, method, id } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result && result.messages) {
      yield loadData({ payload: { id } });
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: result.messages.join(' '),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.SEND_REQUEST, sendInvoiceRequest)]);
}
